module.exports = __webpack_public_path__ + "static/media/mooring_marker_light_blue.0afd4b9f.svg";